// Datos administrativos de Galicia: 4 provincias + 53 comarcas + 313 concellos.
// Fonte: Decreto 65/1997 da Xunta. Nomes oficiais en galego.
//
// Estrutura:
//   COMARCAS = [{ nome, provincia, concellos: [String] }]
//   PROVINCIAS = [String]
//
// Exporta tamén:
//   ALL_LOCATIONS — array unificado para o combobox de busca:
//     [{ id, label, type: "provincia"|"comarca"|"concello", parent, comarca, provincia }]

export const PROVINCIAS = ["A Coruña", "Lugo", "Ourense", "Pontevedra"];

export const COMARCAS = [
  // ─── A CORUÑA ────────────────────────────────────────────────────────────
  { nome: "A Coruña", provincia: "A Coruña", concellos: ["Abegondo", "Arteixo", "Bergondo", "Cambre", "Carral", "A Coruña", "Culleredo", "Oleiros", "Sada"] },
  { nome: "Santiago", provincia: "A Coruña", concellos: ["Ames", "Boqueixón", "Brión", "Santiago de Compostela", "Teo", "Val do Dubra", "Vedra"] },
  { nome: "Ferrol", provincia: "A Coruña", concellos: ["Ares", "Cedeira", "Fene", "Ferrol", "Moeche", "Mugardos", "Narón", "Neda", "San Sadurniño", "As Somozas", "Valdoviño"] },
  { nome: "Bergantiños", provincia: "A Coruña", concellos: ["Cabana de Bergantiños", "Carballo", "Coristanco", "A Laracha", "Laxe", "Malpica de Bergantiños", "Ponteceso"] },
  { nome: "Barbanza", provincia: "A Coruña", concellos: ["Boiro", "A Pobra do Caramiñal", "Rianxo", "Ribeira"] },
  { nome: "Betanzos", provincia: "A Coruña", concellos: ["Aranga", "Betanzos", "Coirós", "Curtis", "Irixoa", "Miño", "Oza-Cesuras", "Paderne", "Vilarmaior", "Vilasantar"] },
  { nome: "Ordes", provincia: "A Coruña", concellos: ["Cerceda", "Frades", "Mesía", "Ordes", "Oroso", "Tordoia", "Trazo"] },
  { nome: "Noia", provincia: "A Coruña", concellos: ["Lousame", "Noia", "Outes", "O Porto do Son"] },
  { nome: "Eume", provincia: "A Coruña", concellos: ["A Capela", "As Pontes de García Rodríguez", "Cabanas", "Pontedeume", "Monfero"] },
  { nome: "Fisterra", provincia: "A Coruña", concellos: ["Cee", "Corcubión", "Dumbría", "Fisterra", "Muxía"] },
  { nome: "Terra de Soneira", provincia: "A Coruña", concellos: ["Camariñas", "Vimianzo", "Zas"] },
  { nome: "Arzúa", provincia: "A Coruña", concellos: ["Arzúa", "Boimorto", "O Pino", "Touro"] },
  { nome: "O Sar", provincia: "A Coruña", concellos: ["Dodro", "Padrón", "Rois"] },
  { nome: "Xallas", provincia: "A Coruña", concellos: ["Mazaricos", "Santa Comba"] },
  { nome: "Muros", provincia: "A Coruña", concellos: ["Carnota", "Muros"] },
  { nome: "Ortegal", provincia: "A Coruña", concellos: ["Cariño", "Cerdido", "Mañón", "Ortigueira"] },
  { nome: "Terra de Melide", provincia: "A Coruña", concellos: ["Melide", "Santiso", "Sobrado", "Toques"] },
  { nome: "A Barcala", provincia: "A Coruña", concellos: ["A Baña", "Negreira"] },

  // ─── LUGO ────────────────────────────────────────────────────────────────
  { nome: "Lugo", provincia: "Lugo", concellos: ["Castroverde", "O Corgo", "Friol", "Guntín", "Lugo", "Outeiro de Rei", "Portomarín", "Rábade"] },
  { nome: "Terra Chá", provincia: "Lugo", concellos: ["Abadín", "Begonte", "Castro de Rei", "Cospeito", "Guitiriz", "Muras", "A Pastoriza", "Vilalba", "Xermade"] },
  { nome: "Terra de Lemos", provincia: "Lugo", concellos: ["Bóveda", "Monforte de Lemos", "Pantón", "A Pobra do Brollón", "O Saviñao", "Sober"] },
  { nome: "A Mariña Central", provincia: "Lugo", concellos: ["Alfoz", "Burela", "Foz", "Lourenzá", "Mondoñedo", "O Valadouro"] },
  { nome: "A Mariña Occidental", provincia: "Lugo", concellos: ["Cervo", "Ourol", "O Vicedo", "Viveiro", "Xove"] },
  { nome: "Sarria", provincia: "Lugo", concellos: ["O Incio", "Láncara", "Paradela", "O Páramo", "Samos", "Sarria", "Triacastela"] },
  { nome: "A Mariña Oriental", provincia: "Lugo", concellos: ["Barreiros", "A Pontenova", "Ribadeo", "Trabada"] },
  { nome: "Chantada", provincia: "Lugo", concellos: ["Carballedo", "Chantada", "Taboada"] },
  { nome: "Os Ancares", provincia: "Lugo", concellos: ["Becerreá", "As Nogais", "Baralla", "Cervantes", "Navia de Suarna", "Pedrafita do Cebreiro"] },
  { nome: "A Ulloa", provincia: "Lugo", concellos: ["Antas de Ulla", "Monterroso", "Palas de Rei"] },
  { nome: "Meira", provincia: "Lugo", concellos: ["Meira", "Pol", "Ribeira de Piquín", "Riotorto"] },
  { nome: "Quiroga", provincia: "Lugo", concellos: ["Folgoso do Courel", "Quiroga", "Ribas de Sil"] },
  { nome: "A Fonsagrada", provincia: "Lugo", concellos: ["Baleira", "A Fonsagrada", "Negueira de Muñiz"] },

  // ─── OURENSE ─────────────────────────────────────────────────────────────
  { nome: "Ourense", provincia: "Ourense", concellos: ["Amoeiro", "Barbadás", "Coles", "Esgos", "Nogueira de Ramuín", "Ourense", "O Pereiro de Aguiar", "A Peroxa", "San Cibrao das Viñas", "Taboadela", "Toén", "Vilamarín"] },
  { nome: "O Carballiño", provincia: "Ourense", concellos: ["Beariz", "Boborás", "O Carballiño", "O Irixo", "Maside", "Piñor", "Punxín", "San Amaro", "San Cristovo de Cea"] },
  { nome: "Valdeorras", provincia: "Ourense", concellos: ["O Barco de Valdeorras", "O Bolo", "Carballeda de Valdeorras", "Larouco", "Petín", "A Rúa", "Rubiá", "A Veiga", "Vilamartín de Valdeorras"] },
  { nome: "Verín", provincia: "Ourense", concellos: ["Castrelo do Val", "Cualedro", "Laza", "Monterrei", "Oímbra", "Riós", "Verín", "Vilardevós"] },
  { nome: "A Limia", provincia: "Ourense", concellos: ["Baltar", "Os Blancos", "Calvos de Randín", "Porqueira", "Rairiz de Veiga", "Sandiás", "Sarreaus", "Trasmiras", "Vilar de Barrio", "Vilar de Santos", "Xinzo de Limia"] },
  { nome: "Terra de Celanova", provincia: "Ourense", concellos: ["A Bola", "Cartelle", "Celanova", "Gomesende", "A Merca", "Padrenda", "Pontedeva", "Quintela de Leirado", "Ramirás", "Verea"] },
  { nome: "O Ribeiro", provincia: "Ourense", concellos: ["A Arnoia", "Avión", "Beade", "Carballeda de Avia", "Castrelo de Miño", "Cenlle", "Cortegada", "Leiro", "Melón", "Ribadavia"] },
  { nome: "Allariz-Maceda", provincia: "Ourense", concellos: ["Allariz", "Baños de Molgas", "Maceda", "Paderne de Allariz", "Xunqueira de Ambía", "Xunqueira de Espadanedo"] },
  { nome: "A Baixa Limia", provincia: "Ourense", concellos: ["Bande", "Entrimo", "Lobeira", "Lobios", "Muíños"] },
  { nome: "Viana", provincia: "Ourense", concellos: ["A Gudiña", "A Mezquita", "Viana do Bolo", "Vilariño de Conso"] },
  { nome: "Terra de Trives", provincia: "Ourense", concellos: ["Chandrexa de Queixa", "Manzaneda", "A Pobra de Trives", "San Xoán de Río"] },
  { nome: "Terra de Caldelas", provincia: "Ourense", concellos: ["Castro Caldelas", "Montederramo", "Parada de Sil", "A Teixeira"] },

  // ─── PONTEVEDRA ──────────────────────────────────────────────────────────
  { nome: "Vigo", provincia: "Pontevedra", concellos: ["Baiona", "Fornelos de Montes", "Gondomar", "Mos", "Nigrán", "Pazos de Borbén", "O Porriño", "Redondela", "Salceda de Caselas", "Soutomaior", "Vigo"] },
  { nome: "Pontevedra", provincia: "Pontevedra", concellos: ["Barro", "Campo Lameiro", "Cerdedo-Cotobade", "A Lama", "Poio", "Ponte Caldelas", "Pontevedra", "Vilaboa"] },
  { nome: "O Salnés", provincia: "Pontevedra", concellos: ["Cambados", "O Grove", "A Illa de Arousa", "Meaño", "Meis", "Ribadumia", "Sanxenxo", "Vilagarcía de Arousa", "Vilanova de Arousa"] },
  { nome: "O Morrazo", provincia: "Pontevedra", concellos: ["Bueu", "Cangas", "Marín", "Moaña"] },
  { nome: "O Baixo Miño", provincia: "Pontevedra", concellos: ["A Guarda", "Oia", "O Rosal", "Tomiño", "Tui"] },
  { nome: "O Condado", provincia: "Pontevedra", concellos: ["Mondariz", "Mondariz-Balneario", "As Neves", "Ponteareas", "Salvaterra de Miño"] },
  { nome: "Deza", provincia: "Pontevedra", concellos: ["Agolada", "Dozón", "Lalín", "Rodeiro", "Silleda", "Vila de Cruces"] },
  { nome: "Caldas", provincia: "Pontevedra", concellos: ["Caldas de Reis", "Catoira", "Cuntis", "Moraña", "Pontecesures", "Portas", "Valga"] },
  { nome: "Tabeirós-Terra de Montes", provincia: "Pontevedra", concellos: ["A Estrada", "Forcarei"] },
  { nome: "A Paradanta", provincia: "Pontevedra", concellos: ["Arbo", "A Cañiza", "Covelo", "Crecente"] },
];

// Lista plana para combobox: { id, label, type, ...extras }
// Inclúe os 4 niveis (provincia, comarca, concello) cunha desambiguación
// no label cando hai conflictos (ex. "Pontevedra" é provincia E comarca E concello).
export const ALL_LOCATIONS = (() => {
  const out = [];
  // Provincias
  for (const prov of PROVINCIAS) {
    out.push({
      id: `prov:${prov}`,
      label: prov,
      sub: "Provincia",
      type: "provincia",
      provincia: prov,
    });
  }
  // Comarcas
  for (const c of COMARCAS) {
    out.push({
      id: `comarca:${c.nome}`,
      label: `Comarca ${c.nome}`,
      sub: c.provincia,
      type: "comarca",
      comarca: c.nome,
      provincia: c.provincia,
    });
  }
  // Concellos
  for (const c of COMARCAS) {
    for (const con of c.concellos) {
      out.push({
        id: `con:${con}|${c.nome}`,
        label: con,
        sub: `${c.nome} · ${c.provincia}`,
        type: "concello",
        concello: con,
        comarca: c.nome,
        provincia: c.provincia,
      });
    }
  }
  return out;
})();

// Helpers de busca:
// Devolve normalize lowercase sen acentos para fuzzy match.
const normalize = (s) =>
  (s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

export function searchLocations(query, limit = 12) {
  if (!query || query.trim().length < 2) {
    // Sen consulta: devolve as 4 provincias coma sugestion inicial
    return ALL_LOCATIONS.filter((l) => l.type === "provincia").slice(0, limit);
  }
  const q = normalize(query);
  const matches = ALL_LOCATIONS.filter((l) => normalize(l.label).includes(q) || normalize(l.sub).includes(q));
  // Ordenar: starts-with primeiro, despois inclúe.
  matches.sort((a, b) => {
    const aStarts = normalize(a.label).startsWith(q) ? 0 : 1;
    const bStarts = normalize(b.label).startsWith(q) ? 0 : 1;
    return aStarts - bStarts;
  });
  return matches.slice(0, limit);
}

// Para validación de publicación: devolve True se 'value' é un concello válido.
export function isValidConcello(value) {
  const v = normalize(value);
  return ALL_LOCATIONS.some((l) => l.type === "concello" && normalize(l.label) === v);
}

// Devolve a comarca dun concello (helper para publicacións).
export function getComarcaFromConcello(concello) {
  const v = normalize(concello);
  const found = ALL_LOCATIONS.find((l) => l.type === "concello" && normalize(l.label) === v);
  return found?.comarca || null;
}
